import { WebSocketClientOptions, WSConnection } from '@hakimo-ui/hakimo/types';
import {
  AlarmDetailWsContext,
  useWebsocketConnect,
} from '@hakimo-ui/hakimo/util';
import { ReactNode, useMemo } from 'react';

interface Props {
  url: string;
  getAccessToken?: () => Promise<string>;
  children: ReactNode;
}

export function AlarmDetailProvider(props: Props) {
  const { children, url, getAccessToken } = props;

  const websocketClientOptions: WebSocketClientOptions = useMemo(
    () => ({
      isDuplicateSessionAllowed: false,
      autoReconnect: true,
      dataTypeKey: 'type',
      retryConfig: {
        maxRetries: 20,
      },
    }),
    []
  );

  const { disconnect, send, subscribe, wsConnectionState } =
    useWebsocketConnect(url, getAccessToken, websocketClientOptions);

  const contextVal: WSConnection = {
    connectionState: wsConnectionState,
    subscribe,
    send,
    disconnect,
  };

  return (
    <AlarmDetailWsContext.Provider value={contextVal}>
      {children}
    </AlarmDetailWsContext.Provider>
  );
}
